"use strict";

exports.__esModule = true;
exports.PredefinedCommentsPanel = void 0;
var _core = require("@blueprintjs/core");
var _react = _interopRequireWildcard(require("react"));
var _Core = require("../../../Core");
var _PredefinedCommentsContext = require("../../PredefinedCommentsContext");
var _styles = require("../../styles");
var _reactDebounceInput = require("react-debounce-input");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var PredefinedCommentsPanel = exports.PredefinedCommentsPanel = function PredefinedCommentsPanel() {
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var _useContext2 = (0, _react.useContext)(_PredefinedCommentsContext.PredefinedCommentsContext),
    defaultComments = _useContext2.settings.defaultComments,
    addComment = _useContext2.addComment,
    deleteComment = _useContext2.deleteComment,
    setComment = _useContext2.setComment;
  return /*#__PURE__*/_react["default"].createElement("section", null, /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      width: "100%",
      display: "flex",
      justifyContent: "end",
      marginTop: "1rem"
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    intent: _core.Intent.PRIMARY,
    onClick: function onClick() {
      return addComment("");
    },
    "data-testid": "PredefinedCommentsPanel.Button.AddComment",
    minimal: true
  }, translate("PredefinedCommentsPanel.Button.AddComment", "Add New"))), /*#__PURE__*/_react["default"].createElement("div", null), defaultComments.map(function (comment, commentIndex) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/jsx-key
      _react["default"].createElement(_styles.CommentLine, {
        "data-testid": "PredefinedCommentsPanel.CommentLine-" + commentIndex
      }, /*#__PURE__*/_react["default"].createElement(_reactDebounceInput.DebounceInput, {
        element: _core.InputGroup,
        minLength: 2,
        debounceTimeout: 300,
        fill: true,
        rows: 2,
        value: comment.comment,
        style: {
          width: "100%"
        },
        "data-testid": "PredefinedCommentsPanel.Input-" + commentIndex,
        onChange: function onChange(e) {
          setComment(commentIndex, Object.assign({}, comment, {
            comment: e.target.value
          }));
        }
      }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
        minimal: true,
        icon: "trash",
        onClick: function onClick() {
          return deleteComment(commentIndex);
        },
        "data-testid": "PredefinedCommentsPanel.TrashButton-" + commentIndex
      }))
    );
  }));
};